var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-tree"},_vm._l((_vm.data),function(node){return _c('tree-node',_vm._g(_vm._b({key:node.id,ref:"treeNode",refInFor:true,attrs:{"node":node,"edit":_vm.edit,"select_id":_vm.select_id}},'tree-node',_vm.$attrs,false),_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }